<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { globalStatus }  from "@/helpers/helper"
import OdemeAl from "./odeme_al"
import SatisEkle from "./satis_ekle"
import OdemeGecmisi from "./odeme_gecmisi"
import EskiOdemeGecmisi from "./eski_odeme_gecmisi"

export default {
  page: {
    title: "Bayi Bakiye Hareket",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    OdemeAl,
    OdemeGecmisi,
    EskiOdemeGecmisi,
    SatisEkle
  },
  data() {
    return {
        list: {},
        title: "BAYİ BAKİYE HAREKETLERİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "BAYİ BAKİYE HAREKETLERİ",
            active: true,
          },
        ],
        isLoading: false,
        detailSearch:true,
        form:{},
        odemeGecmisiDetay:{},
        eskiOdemeGecmisiDetay:{},
        odemeAlDetay:{},
        satisEkleDetay:{},
        rows: [],
        buttons:[
            { title:"Tahsilat Ekle", icon:'bx bx-credit-card', func:this.odemeAl},  // borc kolonu türü yok 
            { title:"Satış Ekle", icon:'bx bx-credit-card', func:this.satis},       // ödeme türü yok
            { title:"Güncel Ödeme Geçmişi", icon:'bx bx-history', func:this.odemeGecmisi},
            { title:"Eski Paneldeki Ödeme Geçmişi", icon:'bx bx-history', func:this.exOdemeGecmisi},
        ],  
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        url: "/dealers/balances",
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa', // for 'pages' mode
          infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
      },
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
        {
          field: '#',
          sortable: false,
          thClass: 'width-50',
        },
        {
          label: 'İsim Soyisim',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'İsim Soyisim Filtrele',
            filterDropdownItems: [],
          },
        },
        {
          label: 'Kullanıcı Adı',
          field: 'username',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Kullanıcı Adı Filtrele',
            filterDropdownItems: [ ],
          },
        },
        {
          label: 'Bakiye',
          field: 'credit',
          sortable: false,
          tdClass:'text-end',
          filterOptions: {
            enabled: false,
          },
        },
      ],
    };
  },
  mounted() {
    this.date()
    this.loadItems()
  },
  methods: {
    date(){
        //var currentDate = new Date();
        //var firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        //var lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        //this.form.startdate= this.formatDate(firstDay),
        //this.form.startdateend= this.formatDate(lastDay)
    },

    formatDate(date) {
        var day = date.getDate();
        var month = date.getMonth() + 1; // JavaScript'te aylar 0'dan başlar, bu yüzden +1 ekliyoruz
        var year = date.getFullYear();

        // Gerekirse, gün ve ayı iki haneli yapmak için sıfır ekleyebilirsiniz
        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;
        
        return year + '-' + month + '-' + day;
    },
    status(rowObj) {
      return globalStatus(rowObj.status);
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.rows = response.rows
      })
    },
    getFromServer() {
        return new Promise((resolve, reject) => {
            this.$http.post(this.url, this.serverParams)
            .then(res => {
                resolve({
                rows: res.data,
                })
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    formSubmit() {
        this.updateParams({ columnFilters : this.form})
        this.loadItems()
    },
    odemeGecmisi(props){
       this.odemeGecmisiDetay = { ...this.form, id : props.id, name:props.name }
       this.$parent.$bvModal.show('odeme_gecmisi')
    }, 
    odemeAl(props){
       this.odemeAlDetay = props
       this.$parent.$bvModal.show('odeme_al')
    },
    exOdemeGecmisi(props){
      this.eskiOdemeGecmisiDetay = props
      this.$parent.$bvModal.show('eski_odeme_gecmisi')
      
    },
    satis(props){
      this.satisEkleDetay = props
      this.$parent.$bvModal.show('satis_ekle')
    },
    filter(val){
      if(val.length < 3) return

        this.updateParams({ columnFilters : this.form })
        this.loadItems()
    },
    async excelExport() {

        const currentDate = new Date();

        const filename = `${currentDate.getFullYear()}${('0' + (currentDate.getMonth() + 1)).slice(-2)}${('0' + currentDate.getDate()).slice(-2)}${('0' + currentDate.getHours()).slice(-2)}${('0' + currentDate.getMinutes()).slice(-2)}${('0' + currentDate.getSeconds()).slice(-2)}_Tahsilatlar.xlsx`;

        this.$http.post('/dealers/balances?excel=true', this.serverParams, { responseType: 'blob' })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            link.setAttribute('type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(error => {
            // eslint-disable-next-line no-console
            console.error('Excel dosyası indirilirken bir hata oluştu:', error);
        });
        
    },
  },
};
</script>

<template>
  <Layout>
    <OdemeAl :data="odemeAlDetay" />
    <OdemeGecmisi :data="odemeGecmisiDetay"  />
    <EskiOdemeGecmisi :data="eskiOdemeGecmisiDetay" />
    <SatisEkle :data="satisEkleDetay" />

    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-md-6 offset-lg-6 text-end">
            <div class="button-items mx-2">
                <button 
                    class="btn btn-success" 
                    type="button"  
                    @click="excelExport">
                    Excel'e Al
                </button>
                <button 
                    class="btn btn-outline-light bg-light" 
                    :class="{ activeClass: detailSearch }"
                    type="button"  
                    @click="detailSearch = !detailSearch">
                    <i class="bx bx-filter-alt"></i> Detaylı Arama
                </button>
            </div>
        </div>
     <Transition name="fade" v-if="detailSearch">
        <div class="offset-lg-6 col-lg-6">
          <div class="card">
            <div class="card-body">
              <form class="needs-validation" @submit.prevent="formSubmit">
                <div class="row">
                    <div class="col-xl-8">
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <label class="d-flex justify-content-between">Tarih Aralığı
                                <span 
                                    v-if="form.startdate || form.startdateend" 
                                    class="text-danger" 
                                    @click="form.startdate= '' ;form.startdateend= ''">
                                    temizle</span>
                                </label>
                                <div class="input-group">
                                <input type="date" class="form-control"  v-model="form['startdate']">
                                <button style="border:0;background: transparent;">  - </button>
                                <input type="date" class="form-control"  v-model="form['startdateend']">
                                </div>
                            </div>
                        </div>
                    </div>
                  <div class="col-xl-4">
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <label>-</label>
                        <div class="button-items">
                            <button 
                              type="submit"
                              class="btn btn-primary w-100 "   
                              >
                              Sorgula
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- end card -->
          </div>
        </div>
      </div>
    </Transition>
      <!-- end col -->
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-1">
          <div class="card-body">
            <input type="text" class="form-control" placeholder="En az 3 karakter giriniz!" v-model="form.query" @keyup="filter($event.target.value)">
          </div>
        </div>
      </div>
    </div>
    <div class="row">     
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                  <table class="table table-hover">
                      <thead>
                          <tr>
                              <th></th>
                              <th>Bayi</th>
                              <th class="text-end">Tarih Aralığındaki Bakiye<br/>({{form.startdate}} - {{ form.startdateend }})</th>
                              <th class="text-end">Tahsilat</th>
                              <th class="text-end">Bakiye</th>
                          </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row,i) in rows" :key="i">
                            <td>
                                <b-dropdown
                                class="ms-2 "
                                toggle-class="font-size-16 p-0"
                                toggle-tag="a"
                                variant="white"
                                right
                                >
                                  <template #button-content>
                                    <i class="mdi mdi-dots-horizontal"></i>
                                    </template>
                                    <template   
                                    v-for="(button,i) in buttons" >
                                    <b-dropdown-item 
                                    :key="i" 
                                    @click="button.func(row)">
                                    <i class="bx" :class="`bx-${button.icon}`"></i> {{ button.title }}
                                    </b-dropdown-item>
                                  </template>
                                </b-dropdown>
                            </td>
                            <td>{{ row.name }}</td>
                            <td class="text-end">{{ $paraFormat(row.balance) }}</td>
                            <td class="text-end">{{ $paraFormat(row.collect) }}</td>
                            <td class="text-end">{{ $paraFormat(row.credit) }}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan=2 class="text-end"></td>
                          <td class="text-end"><strong>{{ $paraFormat(rows.reduce((partialSum, a) => parseFloat(partialSum) + parseFloat(a.balance) , 0)) }}</strong></td>
                          <td class="text-end"><strong>{{ $paraFormat(rows.reduce((partialSum, a) => parseFloat(partialSum) + parseFloat(a.collect) , 0)) }}</strong></td>
                          <td class="text-end"><strong>{{ $paraFormat(rows.reduce((partialSum, a) => parseFloat(partialSum) + parseFloat(a.credit) , 0)) }}</strong></td>
                        </tr>
                      </tfoot>
                  </table>    
              </div>    
            </div>    
          </div>    
        </div>
    </div>
  </Layout>
</template>